<template>
  <div class="power-trade-page">
    <section class="common-section panorama-section">
      <section-title :titleInfo="panoramaTitle"></section-title>
      <div class="panorama-card">
        <img
          class="panorama-background"
          src="../images/dljy/market-panorama.jpg"
          alt="绿色电力交易生态"
        />

        <div class="ability-column ability-column-left">
          <article v-for="item in leftAbilities" :key="item.title" class="ability-card">
            <span class="ability-icon"><operation-icon :name="item.icon"></operation-icon></span>
            <div><h3>{{ item.title }}</h3><p>{{ item.text }}</p></div>
          </article>
        </div>

        <div class="trade-network">
          <svg class="network-lines" viewBox="0 0 760 600" preserveAspectRatio="none" aria-hidden="true">
            <defs>
              <linearGradient id="tradeLine" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stop-color="#9fc6ff" stop-opacity=".35" />
                <stop offset=".5" stop-color="#2072f3" stop-opacity=".92" />
                <stop offset="1" stop-color="#75d8ff" stop-opacity=".5" />
              </linearGradient>
            </defs>
            <path v-for="(line, index) in networkLines" :key="index" :d="line" />
          </svg>
          <article
            v-for="subject in marketSubjects"
            :key="subject.title"
            class="subject-node"
            :class="subject.position"
          >
            <img :src="subject.image" :alt="subject.title" />
            <strong>{{ subject.title }}</strong>
            <small>{{ subject.text }}</small>
          </article>
          <div class="trade-hub">
            <span class="hub-glow"></span>
            <span class="hub-icon"><operation-icon name="power-trade"></operation-icon></span>
            <strong>交易中心</strong>
            <small>智能撮合 · 协同履约</small>
          </div>
        </div>

        <div class="ability-column ability-column-right">
          <article v-for="item in rightAbilities" :key="item.title" class="ability-card">
            <span class="ability-icon"><operation-icon :name="item.icon"></operation-icon></span>
            <div><h3>{{ item.title }}</h3><p>{{ item.text }}</p></div>
          </article>
        </div>
      </div>
    </section>

    <section class="common-section process-section">
      <section-title :titleInfo="processTitle"></section-title>
      <div class="process-flow">
        <article v-for="(item, index) in processSteps" :key="item.title" class="process-step">
          <span class="process-number">0{{ index + 1 }}</span>
          <span class="process-icon"><operation-icon :name="item.icon"></operation-icon></span>
          <div><h3>{{ item.title }}</h3><p>{{ item.text }}</p></div>
        </article>
      </div>
      <div class="process-images">
        <article v-for="item in processSteps" :key="item.image">
          <img :src="item.image" :alt="item.title" />
          <span>{{ item.caption }}</span>
        </article>
      </div>
      <div class="value-grid">
        <article v-for="item in values" :key="item.title">
          <span class="value-icon"><operation-icon :name="item.icon"></operation-icon></span>
          <div><h3>{{ item.title }}</h3><p>{{ item.text }}</p></div>
        </article>
      </div>
    </section>

    <section class="contact-banner">
      <div>
        <h2>携手智融科技，共创绿色交易新价值</h2>
        <p>智能交易 · 高效协同 · 驱动能源市场新未来</p>
      </div>
      <a href="tel:02583585700"><span>立即咨询</span><strong>025-83585700</strong></a>
    </section>
  </div>
</template>

<script>
import SectionTitle from "../../components/section-title.vue";
import OperationIcon from "./operation-icon.vue";

export default {
  name: "NyjhDljy",
  components: { SectionTitle, OperationIcon },
  data() {
    return {
      panoramaTitle: {
        bigtext1: "电力交易全景",
        smallText: "多元主体参与，贯通多类交易，构建高效电力市场生态",
      },
      processTitle: {
        bigtext1: "从策略到履约",
        smallText: "全流程闭环管理，让交易更简单、更可靠",
      },
      leftAbilities: [
        { title: "中长期交易", text: "锁定电量电价，稳定用能周期", icon: "efficiency" },
        { title: "现货交易", text: "灵活申报出清，捕捉市场机会", icon: "schedule" },
        { title: "绿电绿证", text: "采购绿色电力，助力低碳转型", icon: "green" },
      ],
      rightAbilities: [
        { title: "售电服务", text: "一站式服务，交易合规便捷", icon: "shield" },
        { title: "购电优化", text: "多源比选组合，降低用能成本", icon: "efficiency" },
        { title: "协同撮合", text: "智能匹配供需，提升成交效率", icon: "aggregate" },
      ],
      marketSubjects: [
        { title: "发电侧", text: "新能源 / 常规电源", image: require("../images/dljy/nodes/node-generation-transparent.webp"), position: "node-top-left" },
        { title: "电网侧", text: "输电 / 配电企业", image: require("../images/dljy/nodes/node-grid-transparent.webp"), position: "node-top-right" },
        { title: "储能资源", text: "灵活调节 / 时段套利", image: require("../images/dljy/nodes/node-storage-transparent.webp"), position: "node-middle-left caption-above" },
        { title: "用户侧", text: "工商业 / 园区 / 楼宇", image: require("../images/dljy/nodes/node-user-transparent.webp"), position: "node-middle-right caption-above" },
        { title: "充电网络", text: "充电站 / 换电站", image: require("../images/dljy/nodes/node-charging-transparent.webp"), position: "node-bottom-left caption-above" },
        { title: "售电公司", text: "综合能源服务商", image: require("../images/dljy/nodes/node-retailer-transparent.webp"), position: "node-bottom-right caption-above" },
      ],
      networkLines: [
        "M380 300 C300 220 245 160 180 112",
        "M380 300 C460 220 515 160 580 112",
        "M380 300 C290 290 235 290 160 300",
        "M380 300 C470 290 525 290 600 300",
        "M380 300 C300 385 245 430 180 488",
        "M380 300 C460 385 515 430 580 488",
      ],
      processSteps: [
        {
          title: "策略研判",
          text: "洞察市场趋势",
          caption: "行情研判与策略制定",
          icon: "data",
          image: require("../images/dljy/process-strategy.jpg"),
        },
        {
          title: "交易匹配",
          text: "多源优选组合",
          caption: "绿色资源灵活匹配",
          icon: "aggregate",
          image: require("../images/dljy/process-match.jpg"),
        },
        {
          title: "申报参与",
          text: "合规申报出清",
          caption: "智能申报与合规校验",
          icon: "power-trade",
          image: require("../images/dljy/process-submit.jpg"),
        },
        {
          title: "执行跟踪",
          text: "实时监测执行",
          caption: "计划执行与偏差跟踪",
          icon: "schedule",
          image: require("../images/dljy/process-execution.jpg"),
        },
        {
          title: "结算复盘",
          text: "对账结算复盘",
          caption: "精准结算与持续优化",
          icon: "shield",
          image: require("../images/dljy/process-settlement.jpg"),
        },
      ],
      values: [
        { title: "降本优化", text: "优化采购结构", icon: "efficiency" },
        { title: "绿色用能", text: "助力低碳转型", icon: "green" },
        { title: "风险可控", text: "合规透明可追溯", icon: "shield" },
        { title: "灵活参与", text: "适配多类市场", icon: "schedule" },
        { title: "协同服务", text: "全链条专业支持", icon: "aggregate" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.power-trade-page {
  width: 100%;
  color: #17233a;
  background: #fff;
}

.common-section {
  box-sizing: border-box;
  padding: 100px clamp(32px, 8.33vw, 160px);
}

.panorama-section {
  background: linear-gradient(180deg, #f7faff 0%, #fff 100%);
}

.panorama-card {
  height: 690px;
  position: relative;
  overflow: hidden;
  border: 1px solid #e2eaf5;
  border-radius: 12px;
  background: #eef5ff;
  box-shadow: 0 18px 48px rgba(22, 74, 150, 0.1);
}

.panorama-card::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(90deg, rgba(248, 251, 255, 0.94) 0%, rgba(248, 251, 255, 0.3) 25%, rgba(248, 251, 255, 0.06) 50%, rgba(248, 251, 255, 0.3) 75%, rgba(248, 251, 255, 0.94) 100%);
}

.panorama-background {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.ability-column {
  width: 250px;
  position: absolute;
  z-index: 3;
  top: 50%;
  display: grid;
  gap: 18px;
  transform: translateY(-50%);
}

.ability-column-left { left: 24px; }
.ability-column-right { right: 24px; }

.ability-card {
  min-height: 112px;
  box-sizing: border-box;
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  border: 1px solid rgba(185, 207, 240, 0.9);
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 10px 26px rgba(20, 74, 150, 0.1);
  backdrop-filter: blur(6px);
}

.ability-icon,
.subject-icon,
.process-icon,
.value-icon {
  display: grid;
  place-items: center;
  flex: none;
  color: #1f63ea;
}

.ability-icon {
  width: 46px;
  height: 46px;
  padding: 8px;
  box-sizing: border-box;
  border-radius: 50%;
  background: #edf4ff;
}

h3, p { margin: 0; }

.ability-card h3 {
  margin-bottom: 8px;
  font-size: 18px;
  font-weight: 500;
}

.ability-card p {
  color: #7c8798;
  font-size: 12px;
  line-height: 1.55;
}

.trade-network {
  width: 48vw;
  max-width: 760px;
  height: 600px;
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.network-lines {
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;
  overflow: visible;
}

.network-lines path {
  fill: none;
  stroke: url(#tradeLine);
  stroke-width: 2.2;
  stroke-dasharray: 8 6;
  animation: line-flow 12s linear infinite;
}

.subject-node {
  width: 264px;
  min-height: 136px;
  box-sizing: border-box;
  position: absolute;
  display: grid;
  grid-template-columns: 182px minmax(0, 1fr);
  grid-template-rows: 1fr 1fr;
  align-items: center;
  column-gap: 2px;
}

.subject-node > img {
  width: 168px;
  height: 132px;
  grid-row: 1 / span 2;
  display: block;
  object-fit: contain;
  justify-self: center;
  filter: drop-shadow(0 11px 14px rgba(22, 74, 150, 0.18));
}

/* The transparent sources have different aspect ratios, so equal CSS boxes do
   not produce equal visual weight. Tune the wider scenes individually. */
.node-top-right > img { width: 182px; }
.node-middle-left > img { width: 184px; }
.node-middle-right > img { width: 182px; }
.node-bottom-left > img { width: 184px; }
.node-bottom-right > img { width: 188px; }

.subject-node strong {
  align-self: end;
  position: relative;
  z-index: 1;
  margin: 0 0 0 -2px;
  color: #0b356f;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
  letter-spacing: 0.1px;
  white-space: nowrap;
  text-shadow: 0 1px 7px #fff, 0 0 14px #fff, 0 0 22px rgba(255, 255, 255, 0.9);
}

.subject-node small {
  align-self: start;
  position: relative;
  z-index: 1;
  margin: 5px 0 0 -2px;
  color: #526b8a;
  font-size: 12.5px;
  font-weight: 400;
  line-height: 1.45;
  white-space: nowrap;
  text-shadow: 0 1px 7px #fff, 0 0 14px #fff, 0 0 22px rgba(255, 255, 255, 0.9);
}

.node-top-left { top: 0; left: 34px; }
.node-top-right { top: 0; right: 34px; }
.node-middle-left { top: 178px; left: -6px; }
.node-middle-right { top: 178px; right: -6px; }
.node-bottom-left { bottom: 0; left: 34px; }
.node-bottom-right { right: 34px; bottom: 0; }

.caption-above {
  width: 200px;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.caption-above > img {
  order: 3;
  grid-row: auto;
}

.caption-above strong {
  align-self: center;
  margin: 0;
  text-align: center;
}

.caption-above small {
  align-self: center;
  margin: 4px 0 2px;
  text-align: center;
}

.trade-hub {
  width: 180px;
  height: 180px;
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #fff;
  border: 7px solid rgba(255, 255, 255, 0.92);
  border-radius: 50%;
  background: linear-gradient(145deg, #5cb9ff, #0e5be1 65%, #0641ad);
  box-shadow: 0 18px 42px rgba(17, 99, 225, 0.38), inset 0 0 28px rgba(255, 255, 255, 0.34);
  transform: translate(-50%, -50%);
}

.hub-glow {
  position: absolute;
  inset: -25px;
  border: 1px solid rgba(42, 122, 242, 0.35);
  border-radius: 50%;
  box-shadow: 0 0 0 13px rgba(40, 121, 242, 0.08), 0 0 0 27px rgba(40, 121, 242, 0.04);
}

.hub-icon { width: 54px; height: 54px; margin-bottom: 8px; }
.trade-hub strong { font-size: 23px; font-weight: 500; }
.trade-hub small { margin-top: 6px; color: rgba(255, 255, 255, 0.8); font-size: 11px; }

.process-section { background: #fff; }

.process-flow {
  margin-bottom: 28px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}

.process-step {
  min-width: 0;
  position: relative;
  display: flex;
  align-items: center;
  gap: 13px;
}

.process-step:not(:last-child)::after {
  content: "";
  width: calc(100% - 146px);
  height: 1px;
  position: absolute;
  top: 50%;
  left: 132px;
  background: linear-gradient(90deg, #6ca4ff, #c9dcfa);
}

.process-step:not(:last-child)::before {
  content: "";
  position: absolute;
  z-index: 1;
  top: calc(50% - 3px);
  right: 13px;
  border-width: 3px 0 3px 6px;
  border-style: solid;
  border-color: transparent transparent transparent #73a8fa;
}

.process-number {
  position: absolute;
  top: -16px;
  left: 0;
  color: #c7d9f7;
  font-size: 11px;
  letter-spacing: 1px;
}

.process-icon {
  width: 58px;
  height: 58px;
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #bfdaff;
  border-radius: 50%;
  background: #f2f7ff;
}

.process-step h3 { margin-bottom: 7px; font-size: 17px; font-weight: 500; }
.process-step p { color: #8893a4; font-size: 12px; }

.process-images {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  overflow: hidden;
  border-radius: 10px;
}

.process-images article {
  height: 210px;
  position: relative;
  overflow: hidden;
  border-right: 2px solid #fff;
  background: #dfe8f2;
}

.process-images article:last-child { border-right: 0; }
.process-images img { width: 100%; height: 100%; display: block; object-fit: cover; transition: transform .4s; }
.process-images article:hover img { transform: scale(1.035); }
.process-images article::after { content: ""; position: absolute; inset: 50% 0 0; background: linear-gradient(transparent, rgba(5, 29, 68, .86)); }
.process-images span { position: absolute; z-index: 1; right: 16px; bottom: 15px; left: 16px; color: #fff; font-size: 15px; text-align: center; }

.value-grid {
  margin-top: 28px;
  padding: 26px 22px;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  border: 1px solid #e5ebf5;
  border-radius: 9px;
  background: #f8faff;
}

.value-grid article {
  min-width: 0;
  padding: 0 24px;
  display: flex;
  align-items: center;
  gap: 15px;
  border-right: 1px solid #dde6f2;
}

.value-grid article:last-child { border-right: 0; }
.value-icon { width: 44px; height: 44px; }
.value-grid h3 { margin-bottom: 6px; color: #1f63ea; font-size: 17px; font-weight: 500; }
.value-grid p { color: #7d8797; font-size: 12px; }

.contact-banner {
  min-height: 260px;
  box-sizing: border-box;
  padding: 54px clamp(32px, 8.33vw, 160px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
  color: #fff;
  background: linear-gradient(90deg, rgba(5, 59, 155, .96), rgba(18, 103, 226, .8)), url("../images/dljy/dljy-banner.jpg") center 62% / cover no-repeat;
}

.contact-banner h2 { margin: 0 0 15px; font-size: 34px; font-weight: 500; }
.contact-banner p { color: rgba(255, 255, 255, .8); font-size: 18px; }
.contact-banner a { min-width: 235px; padding: 16px 28px; display: flex; flex-direction: column; align-items: center; color: #1f63ea; border-radius: 5px; background: #fff; text-decoration: none; box-shadow: 0 12px 26px rgba(0, 38, 105, .18); }
.contact-banner a span { margin-bottom: 6px; font-size: 15px; }
.contact-banner a strong { font-size: 22px; font-weight: 500; }

@keyframes line-flow { to { stroke-dashoffset: -140; } }

@media (max-width: 1450px) {
  .panorama-card { height: auto; padding: 26px; display: grid; grid-template-columns: 1fr 1fr; gap: 22px; }
  .panorama-background { position: absolute; inset: 0; }
  .trade-network { width: 760px; max-width: 100%; grid-column: 1 / -1; position: relative; top: auto; left: auto; margin: 0 auto; transform: none; }
  .ability-column { width: auto; position: relative; top: auto; display: grid; grid-template-columns: repeat(3, 1fr); transform: none; }
  .ability-column-left { left: auto; grid-column: 1 / -1; grid-row: 2; }
  .ability-column-right { right: auto; grid-column: 1 / -1; grid-row: 3; }
  .ability-card { min-height: 96px; }
}

@media (max-width: 1100px) {
  .process-flow, .process-images, .value-grid { grid-template-columns: repeat(2, 1fr); gap: 18px; }
  .process-step::after, .process-step::before { display: none; }
  .value-grid article { padding: 12px 18px; border-right: 0; }
  .process-images { overflow: visible; }
  .process-images article { border: 0; border-radius: 8px; }
  .process-images article:last-child { grid-column: 1 / -1; }
}

@media (max-width: 760px) {
  .common-section { padding: 70px 22px; }
  .panorama-card { padding: 18px; }
  .trade-network { width: 100%; height: auto; display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
  .network-lines { display: none; }
  .subject-node { width:auto; min-height:118px; padding:8px; position:static; grid-template-columns:96px minmax(0,1fr); border:1px solid rgba(191,211,240,.84); border-radius:10px; background:rgba(255,255,255,.92); box-shadow:0 8px 20px rgba(24,91,184,.08); }
  .subject-node > img { width:96px; height:94px; }
  .subject-node strong,.subject-node small { margin-left:0; text-shadow:none; }
  .caption-above { display:grid; width:auto; }
  .caption-above > img { order:0; grid-row:1 / span 2; }
  .caption-above strong,.caption-above small { align-self:auto; text-align:left; }
  .trade-hub { width: auto; height: auto; min-height: 120px; grid-column: 1 / -1; grid-row: 1; position: relative; top: auto; left: auto; border-radius: 12px; transform: none; }
  .hub-glow { display: none; }
  .ability-column { grid-template-columns: 1fr; }
  .process-flow, .process-images, .value-grid { grid-template-columns: 1fr; }
  .process-images article:last-child { grid-column: auto; }
  .contact-banner { align-items: flex-start; flex-direction: column; }
  .contact-banner h2 { font-size: 28px; }
}
</style>
